import {api} from './api';

export const eventService={
  getEvents: async ()=> (await api('/events?all=1')).events,
  getActiveEvents: async ()=> (await api('/events')).events,
  saveEvent: async (eventData)=>{
    if (eventData.id) {
      await api(`/events/${eventData.id}`,{method: 'PUT',body: eventData});
    } else {
      await api('/events',{method: 'POST',body: eventData});
    }
    return eventService.getEvents();
  },
  toggleStatus: async (id)=>{
    await api(`/events/${id}/toggle`,{method: 'POST'});
    return eventService.getEvents();
  },
};
